import { Component, EventEmitter, Output } from '@angular/core';
import { UploadService } from 'projects/core/src/lib/upload.service';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrl: './signature.component.css'
})
export class SignatureComponent {

  @Output()
  onSignature:EventEmitter<any>=new EventEmitter<any>();


  signature_file="";

  constructor(private uploadService:UploadService){

  }
  
  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': window.innerWidth,
    'canvasHeight': window.innerHeight-200
  };

  
  confirmSignature(sigPad){
    let signature=sigPad.toDataURL().replace("data:image/png;base64,","");
    this.uploadService.uploadImage64(signature,"signatures",(result)=>{
      this.signature_file=result;
      this.onSignature.emit(result);
      this['modalWindow'].close("success");
    },true);

   
  }

  close(){
    this['modalWindow'].close("cancel");
  }
}
